export const routes = {
  home: '/',
  dashboard: '/dashboard',
  showcases: '/showcases',
  featured: '/featured',
  analytics: '/analytics',
  settings: '/settings',
} as const;

export type RoutePath = typeof routes[keyof typeof routes];
